import React, { useContext } from 'react';
import { Image } from '@hz-design-system/web-ui';

import EnvironmentContext from '../../../../contexts/EnvironmentContext';
import { getHeroImageUrl, getLargeHeroImageUrl } from '../../../../utils/getImageUrls';

import { TListingGalleryApi } from 'types/TListing';

import Classes from './HeroImage.module.scss';

type THeroImageProps = {
  imageUrl: string;
  imageSizes: TListingGalleryApi['media']['imageSizes'];
  alt: string;
  onClickHandler: () => void;
};

const HeroImage = ({ imageUrl, alt, onClickHandler, imageSizes }: THeroImageProps) => {
  const { isMobileDevice } = useContext(EnvironmentContext);

  return (
    <div
      className={Classes.root}
      role="button"
      tabIndex={0}
      onClick={onClickHandler}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onClickHandler()}
    >
      <Image
        className={Classes.image}
        src={isMobileDevice ? getHeroImageUrl(imageUrl, imageSizes) : getLargeHeroImageUrl(imageUrl, imageSizes)}
        fetchPriority="high"
        alt={alt}
        title={alt}
        aspectRatio="landscape"
        fit={true}
      />
    </div>
  );
};

export default HeroImage;
